module.exports = __webpack_public_path__ + "static/media/btbms-dt-fr.4f8379e7.jpg";